import React, { useState, useEffect } from 'react';
import { getSourcesForImage } from './imageHelpers';

// ProgressiveImage currently shows thumbnail until small is loaded, then shows small
// with orignal as backup if small is not found.
const ProgressiveImage = props => {
	const { src, alt, style, type } = props;
	const [thumbnailIsFound, setThumbnailIsFound] = useState(false);
	const [smallIsFound, setSmallIsFound] = useState(false);
	const [originalIsFound, setOriginalIsFound] = useState(false);

	const [smallIsNotFound, setSmallIsNotFound] = useState(false);

	const { thumbnail, small, original } = getSourcesForImage(src, type);

	useEffect(() => {
		let thumbEffectActive = true;
		if (thumbnail) {
			const thumbImg = new Image();
			thumbImg.onload = () => {
				if (thumbEffectActive) {
					setThumbnailIsFound(true);
				}
			};
			thumbImg.src = thumbnail;
		}
		return () => {
			thumbEffectActive = false;
		};
	});

	useEffect(() => {
		let smallEffectActive = true;
		if (small && !smallIsNotFound) {
			const smallImg = new Image();
			smallImg.onload = () => {
				if (smallEffectActive) {
					setSmallIsFound(true);
				}
			};
			smallImg.onerror = () => {
				if (smallEffectActive) {
					setSmallIsNotFound(true);
				}
			};
			smallImg.src = small;
		} else setSmallIsNotFound(true);
		return () => {
			smallEffectActive = false;
		};
	});

	useEffect(() => {
		let originalEffectActive = true;
		if (original && smallIsNotFound) {
			const originalImg = new Image();
			originalImg.onload = () => {
				if (originalEffectActive) {
					setOriginalIsFound(true);
				}
			};
			originalImg.src = original;
		}
		return () => {
			originalEffectActive = false;
		};
	});

	const srcToShow = originalIsFound
		? original
		: smallIsFound
		? small
		: thumbnailIsFound
		? thumbnail
		: null;

	return srcToShow ? <img src={srcToShow} style={style} alt={alt} /> : null;
};

export default ProgressiveImage;
